module.exports = __webpack_public_path__ + "images/749417decbee674ba253646bb956ce2d-RIT_Logo_Variations-RGB_Ireland 2.png";